import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { Subscription } from '../models/subscription.model';
import { SubscriptionResponse } from '../models/subscription-response.model';
import { environment_endpoints } from 'src/environments/environment';
import { AbstractService } from '../../subfolders/services/abstract.service';
import { UsersResult } from '../../users/models/usersResult';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionHttpService extends AbstractService {
  private urlSubscription = environment_endpoints.api.subscriptions;
  private urlUsers = environment_endpoints.api.users;
  private headers: HttpHeaders;
  private token = '';

  constructor(
    private httpClient: HttpClient,
    private oauthService: OAuthService,
    private router: Router
  ) {
    super();
    this.token = this.oauthService.getIdToken();
    this.headers = new HttpHeaders().append(
      'Authorization',
      'Bearer ' + this.token
    );
  }

  /**
   * Returns back-end endpoint URL for subscription service.
   *
   * @returns URL for subscription service
   */
  public getUrlSubscription(): string {
    return this.urlSubscription;
  }

  /**
   * Returns all subscriptions that is matching user filters and all subscriptions if there is no user filters.
   *
   * @param params - User filters
   * @returns Multiple subscriptions
   */
  public getSubscriptions(
    params: HttpParams
  ): Observable<SubscriptionResponse> {
    return this.httpClient.get<SubscriptionResponse>(this.urlSubscription, {
      headers: this.headers,
      params,
    });
  }

  getSubscriptionById(id: string): Observable<Subscription> {
    return this.httpClient.get<Subscription>(`${this.urlSubscription}/${id}`, {
      headers: this.headers,
    });
  }
}
